class NavigationMobile extends HTMLElement {
  constructor() {
    super();
    this.currentMenuLevel = 1;
    this.position = this.getAttribute("position");
    this.previousLevelButton = this.querySelector(".js-menu-previous");
    this.inner = this.querySelector(".navigation-mobile-inner-content");
    this.lists = {
      1: [...this.querySelectorAll(".navigation-mobile-list--first")],
      2: [...this.querySelectorAll(".navigation-mobile-list--second")],
      3: [...this.querySelectorAll(".navigation-mobile-list--third")]
    };
    this.addEventListener("click", (e) => {
      if (e.target.tagName === "W3-NAVIGATION-MOBILE") {
        e.preventDefault();
        this.close();
      }
    });
    const openMenuButtons = document.querySelectorAll(this.getAttribute("open-button"));
    for (let i = 0; i < openMenuButtons.length; i++) {
      openMenuButtons[i].addEventListener("click", (e) => {
        e.preventDefault();
        if (!this.classList.contains("visible")) {
          this.open();
        } else {
          this.close();
        }
      });
    }
    this.previousLevelButton.addEventListener("click", () => {
      if (this.currentMenuLevel <= "1") {
        this.close();
      } else {
        this.setActiveLevel(this.currentMenuLevel - 1);
      }
    });
    for (let i = 1; i <= 3; i++) {
      const groupOfLists = this.lists[i];
      for (const list in groupOfLists) {
        const menuNextButtons = groupOfLists[list].querySelectorAll(".js-menu-next");
        for (let j = 0; j < menuNextButtons.length; j++) {
          menuNextButtons[j].addEventListener("click", (e) => {
            e.preventDefault();
            this.updateNavigation(menuNextButtons[j]);
          });
        }
      }
    }
    window.openMobileMenu = this.open;
    window.closeMobileMenu = this.close;
  }
  /**
   * Open the mobile menu
   */
  open() {
    this.classList.add("visible");
    document.body.style.overflowY = "hidden";
  }
  /**
   * Close the mobile menu
   */
  close() {
    this.classList.remove("visible");
    this.setActiveLevel(1);
    document.body.style.overflowY = "auto";
  }
  /**
   * Set the active level of menu displayed. Accepts following values 1 | 2 | 3
   * @param level
   */
  setActiveLevel(level) {
    this.currentMenuLevel = level;
    this.inner.dataset.level = level.toString();
  }
  /**
   * Update navigation from a link element with a data attribute "level"
   * @param link
   */
  updateNavigation(link) {
    this.setActiveLevel(link.dataset.level);
    for (const index in this.lists[link.dataset.level]) {
      this.lists[link.dataset.level][index].classList.remove("visible");
    }
    const ul = link.closest("li").querySelector(".navigation-mobile-list");
    if (ul) {
      ul.classList.add("visible");
    }
  }
}
customElements.define("w3-navigation-mobile", NavigationMobile);
